import React from 'react';
import ReactPlayer from 'react-player';

const Scenario4Video = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/ZQlmY7P5DaI' controls={true} />
        </div>
    );
}

export default Scenario4Video;